export default __webpack_public_path__ + "static/media/laundry.d552e385.svg";